import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ImageAnnotationComponent} from './image-annotation/image-annotation.component';
import {AnnotationCanvasComponent} from './annotation-canvas/annotation-canvas.component';
import {AnnotationDashboardComponent} from './annotation-dashboard/annotation-dashboard.component';
import {SharedModule} from '../shared/shared.module';
import {FormsModule} from '@angular/forms';
import {AnnotationParentsComponent} from './annotation-dashboard/annotation-parents/annotation-parents.component';
import {AnnotationShapeMenuComponent} from './annotation-dashboard/annotation-shape-menu/annotation-shape-menu.component';
import {AnnotationColorMenuComponent} from './annotation-dashboard/annotation-color-menu/annotation-color-menu.component';
import {AnnotationDashboardButtonsComponent} from './annotation-dashboard/annotation-dashboard-buttons/annotation-dashboard-buttons.component';
import {AnnotationDescriptionComponent} from './annotation-dashboard/annotation-description/annotation-description.component';
import {AnnotationPointsComponent} from './annotation-dashboard/annotation-points/annotation-points.component';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {AnnotationDialogComponent} from './annotation-dialog/annotation-dialog.component';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';

@NgModule({
  declarations: [ImageAnnotationComponent, AnnotationCanvasComponent, AnnotationDashboardComponent,
    AnnotationParentsComponent, AnnotationShapeMenuComponent, AnnotationColorMenuComponent,
    AnnotationDashboardButtonsComponent, AnnotationDescriptionComponent, AnnotationPointsComponent,
    AnnotationDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    MatButtonModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatDialogModule
  ],
  exports: [
    AnnotationCanvasComponent,
    AnnotationDashboardComponent,
    AnnotationDialogComponent
  ]
})
export class ImageAnnotationModule {
}
